export const LISTING_EDIT_RESTRICTED_DAYS = 14;

export enum RestrictionType {
  NONE = 0,
  WARNING = 1,
  DENIED = 2,
}

export const RESTRICTED_STATUSES = {
  CLOSED: 'CLOSED',
  EXPIRED: 'CANCELED',
  CANCELED: 'EXPIRED',
} as const;

export type RestrictedStatusType =
  (typeof RESTRICTED_STATUSES)[keyof typeof RESTRICTED_STATUSES];
